import * as bootstrap from 'bootstrap';
import './primary-navigation';
import './gravity-forms';
import './share-post';
import './tabs-block-frontend';
import './accordion-block-frontend';
import './ga4';
import './scroll-to-top';
import './posts-list';
